import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'tab1',
    pathMatch: 'full'
  },
  {
    path: '',
    loadChildren: () => import('../pages/tabs/tabs.module').then(m => m.TabsModule)
  },
  // {path:'notification', loadChildren:()=>
  //   import('../pages/notification/notification.module').then(m=>m.NotificationModule)
  // },
  {path:'auth', loadChildren:()=>import('../pages/login/auth.module').then(m=>m.AuthModule)},
  {path:'nearby',
    loadChildren:()=>import('../pages/nearby/nearby.module').then(m=>m.NearbyModule)
  },
  {
    path:'stracker',
    loadChildren:()=>import('../tracker/sencha-tracker/sencha-track-module').then(m=>m.StrackerTrackModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule],
  schemas: [
              CUSTOM_ELEMENTS_SCHEMA,
              NO_ERRORS_SCHEMA
  ],
})
export class AppRoutingModule { }
